@if (inWartung()) {
  <app-wartung [wartungStart]="wartungStart.toJSDate()" [wartungEnde]="wartungEnde.toJSDate()" [showZurStartseiteButton]="false" />
} @else {
  @if (wartungAngekuendigt()) {
    <div class="h-[3rem] w-full bg-taures-danger-red-800 flex items-center justify-center">
      <span class="taures-neutrals-white h5-regular">
        +++ ACHTUNG: Unsere Bewerber-Software wird heute ab {{ wartungStart.toFormat('HH:mm') }} Uhr gewartet. Alle bis dahin nicht gespeicherten
        Daten gehen verloren. +++
      </span>
    </div>
  }
  <taures-layout-compact appRootUrl="#" appName="Bewerbung">
    <ng-container ngProjectAs="content">
      <div class="header-image-container"></div>
      <p-card class="content-container mb-8">
        <router-outlet></router-outlet>
      </p-card>
      <div class="content-wrapper">
        <app-footer></app-footer>
      </div>
    </ng-container>
  </taures-layout-compact>
}

<taures-toast></taures-toast>
<taures-confirm-dialog severity="warn" key="warn-confirm-dialog" confirmDialogWidth="500px" />
